<template>
  <table :class="['table', 'table-sm', type]">
    <thead>
      <tr>
        <td colspan="100%">
          <div>
            <b-alert variant="warning" show style="font-weight: bold"
              >Non-Contributing Courses:
              <b-form inline>
                <!-- <b-form-radio class="mr-2" name="showNonContributors" v-on:click="form.ncCourses = true; form.spCourses = true;" v-model="form.ncCourses" :value="true">Show</b-form-radio> -->
                <!-- <b-form-radio name="showNonContributors" v-model="form.ncCourses" v-on:click="form.ncCourses = false; form.spCourses = false;" :value="false">Hide</b-form-radio> -->

                <!-- v-model must be set to have the button checked by default -->
                <b-form-radio
                  class="mr-2"
                  v-model="showNoncontributingClasses"
                  :value="true"
                  v-on:click="showNoncontributingClasses = true"
                  >Show</b-form-radio
                >
                <b-form-radio
                  v-on:click="showNoncontributingClasses = false"
                  v-model="showNoncontributingClasses"
                  :value="false"
                  >Hide</b-form-radio
                >
              </b-form>
            </b-alert>
          </div>
        </td>
      </tr>

      <tr style="cursor: pointer">
        <th></th>
        <th v-on:click="sortBy('course')">Course</th>
        <th v-on:click="sortBy('sln')">SLN</th>
        <th v-on:click="sortBy('location')">Mode/Location</th>
        <th v-on:click="sortBy('enrolled')">Enrollment</th>
      </tr>
    </thead>
    <tbody>
      <template v-for="(group, index) in groupedClassRecords">
        <!-- If "showNoncontributingClasses" is true, or if contributesToTeaching is true and schedulePrint is true, show the class -->
        <!-- <tr :class="{'class-group': ((index % 2 == 0 && group.id !== 'null') || (group.id == 'null' && cIndex % 2 == 0)), 'table-danger': !course.contributesToTeaching}"  -->
        <tr
          :class="{
            'class-group': colorComputed(group.id, index, cIndex),
            'table-danger': !course.contributesToTeaching,
          }"
          :key="course.id"
          v-for="(course, cIndex) in group.courses"
          v-show="
            showNoncontributingClasses ||
            (course.contributesToTeaching && course.schedulePrint)
          "
        >
          <td
            v-if="cIndex === 0 && group.id !== 'null'"
            :rowspan="group.courses.length"
            style="vertical-align: middle"
          >
            <font-awesome-icon v-if="group.id !== 'null'" icon="link" />
            <font-awesome-icon
              icon="minus-circle"
              v-b-tooltip.hover
              title="This course does not contribute to Teaching %."
              v-if="!course.contributesToTeaching"
            ></font-awesome-icon>
          </td>
          <td v-else-if="group.id === 'null'">
            <font-awesome-icon
              icon="minus-circle"
              v-b-tooltip.hover
              title="This course does not contribute to Teaching %."
              v-if="!course.contributesToTeaching"
            ></font-awesome-icon>
          </td>
          <td>
            {{ course.subjectCode }} {{ course.catalogNumber }} -
            {{ course.courseTitle }}<br />Section: {{ course.classSectionCode
            }}<br />Session: {{ course.sessionCode }}
          </td>
          <td>{{ course.scheduleLineNumber }}</td>
          <td>{{ course.instructionMode }}<br />{{ course.locationCode }}</td>
          <td>{{ course.enrollmentTotal }}</td>
        </tr>
      </template>
    </tbody>
  </table>
</template>
<script>
export default {
  name: "CombinedCourses",
  data() {
    return {
      sortKeys: [],
      sortDirection: [],
      currDir: "desc",
      sortDir: "asc",
      showNoncontributingClasses: true,
      options: [
        { text: "Show", value: true },
        { text: "Hide", value: false },
      ],
    };
  },
  props: {
    courses: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      required: false,
      default: "",
    },
  },

  methods: {
    colorComputed: function (groupID, index, cIndex) {
      // logic for outer group index
      if (groupID != 'null' && index % 2 == 0) return true;
      // if cIndex should start with gray row
      else if (groupID == 'null' && index % 2 == 0 && cIndex % 2 == 0)
        return true;
      // if cIndex should start with white row
      else if (groupID == 'null' && index % 2 == 1 && cIndex % 2 == 1)
        return true;
      else return false;
    },

    sortBy: function (mode) {
      this.sortDir = this.currDir == "asc" ? "desc" : "asc";

      switch (mode) {
        case "course":
          this.sortKeys = ["subjectCode", "catalogNumber", "courseTitle"];

          // this is just a parameter for _orderBy
          this.sortDirection = [this.sortDir, this.sortDir, this.sortDir];
          break;

        case "sln":
          this.sortKeys = "scheduleLineNumber";

          // this is just a parameter for _orderBy
          this.sortDirection = [this.sortDir];
          break;

        case "location":
          this.sortKeys = "location";

          // this is just a parameter for _orderBy
          this.sortDirection = [this.sortDir];
          break;

        case "enrolled":
          this.sortKeys = "enrolled";

          // this is just a parameter for _orderBy
          this.sortDirection = [this.sortDir];
          break;

        default:
          break;
      }

      this.currDir = this.sortDir;
    },
  },

  computed: {
    groupedClassRecords: function () {
      var data = _.chain(this.courses)
        // Group the elements of Array based on `color` property
        .groupBy("combinedSectionId")
        // `key` is group's name (color), `value` is the array of objects
        .map((value, key) => ({
          id: key,
          courses: _.orderBy(value, this.sortKeys, this.sortDirection),
        }))
        .value();

      return data;
    },
  },
};
</script>
<style scoped>
.group-last-row {
  border-bottom: 1px solid black;
}
.group-first-row {
  border-top: 1px solid black;
}

.plain-group {
  background-color: transparent;
}

.table-plain tbody tr,
.table-plain tbody tr:hover,
.table-plain tbody td {
  background-color: transparent;
}
.table-plain tbody tr:nth-of-type(odd) {
  background-color: transparent;
}
.class-group {
  background-color: rgba(0, 0, 0, 0.05);
}
.non-contributing {
  color: red;
  border-color: red;
}
</style>
